import React, { useEffect, useRef, useState } from "react";
import confetti from "canvas-confetti";
import { useTheme } from "../../context/ThemeContext"; // Assuming this is the correct path
import "./LaunchingSoon.scss";

// NavBar and StandardFooter can be re-imported if you decide to use them.
// import NavBar from "../../components/layout/Navbar";
// import StandardFooter from "../../components/Footer/StandardFooter";

const LaunchingSoon: React.FC = () => {
    const { isDarkMode, toggleDarkMode } = useTheme();
    const [initialDarkModeState, setInitialDarkModeState] = useState<boolean | null>(null);
    const animationFrameId = useRef<number | null>(null);
    const confettiCanvasRef = useRef<HTMLCanvasElement | null>(null);
    let confettiInstance: ReturnType<typeof confetti.create> | null = null; // Made it a let, not a ref for direct reassignment

    useEffect(() => {
        // Store the initial theme state and switch to dark mode if not already set
        setInitialDarkModeState(isDarkMode);
        if (!isDarkMode) {
            toggleDarkMode();
        }

        // Create and append canvas for confetti
        const canvasElement = document.createElement("canvas");
        canvasElement.id = "confetti-canvas"; // SCSS styles target this ID
        document.body.appendChild(canvasElement);
        confettiCanvasRef.current = canvasElement;

        if (confettiCanvasRef.current) {
            // Directly assign to confettiInstance
            confettiInstance = confetti.create(confettiCanvasRef.current, {
                resize: true,
                useWorker: true,
            });
        }

        const launchParticles = () => {
            if (confettiInstance) {
                confettiInstance({
                    particleCount: 2, // Increased for prominence
                    angle: 270,
                    spread: 10, // Wider spread for full screen effect
                    startVelocity: 5, // Slightly faster
                    origin: { y: -0.05, x: Math.random() },
                    gravity: 0.9, // Adjusted gravity
                    drift: Math.random() * 0.5 - 0.25, // More drift
                    ticks: 300,
                    colors: ["#9f8f5e", "#BFAB78", "#E0D2A3", "#F0E68C", "#FAFAD2"], // Brighter and more varied gold/light yellow palette
                    scalar: Math.random() * 0.6 + 0.4, // Slightly larger particles
                    // zIndex is handled by the canvas element's style in SCSS
                });
            }
            animationFrameId.current = requestAnimationFrame(launchParticles);
        };

        if (confettiInstance) {
            animationFrameId.current = requestAnimationFrame(launchParticles);
        }

        return () => {
            if (initialDarkModeState !== null && isDarkMode !== initialDarkModeState) {
                const currentGlobalDarkMode = document.body.classList.contains("dark-mode");
                if (currentGlobalDarkMode !== initialDarkModeState) {
                    toggleDarkMode();
                }
            }

            if (animationFrameId.current) {
                cancelAnimationFrame(animationFrameId.current);
            }

            // Define a type for the confetti instance that might have a reset method
            type ConfettiInstanceWithOptionalReset = ((options: confetti.Options) => void) & {
                reset?: () => void;
            };
            const instanceWithReset = confettiInstance as ConfettiInstanceWithOptionalReset | null;

            // Attempt to clean up confetti instance by resetting it, if method exists
            if (instanceWithReset && typeof instanceWithReset.reset === "function") {
                instanceWithReset.reset();
            } else if (typeof confetti.reset === "function") {
                // Fallback to global reset if instance reset isn't available
                // confetti.reset(); // This is global and might affect other confetti instances.
            }
            confettiInstance = null;

            if (confettiCanvasRef.current) {
                document.body.removeChild(confettiCanvasRef.current);
                confettiCanvasRef.current = null;
            }
        };
         
    }, []); // Run once on mount and clean up on unmount

    return (
        <div className="launching-soon-page">
            {/* <NavBar /> */}
            <section className="launching-soon-hero-section">
                <div className="hero-content">
                    <h1 className="hero-title-main">MAX Aspire</h1>
                    <h1 className="hero-title-sub">Launching Soon...</h1>
                </div>
            </section>
            {/* <StandardFooter /> */}
        </div>
    );
};

export default LaunchingSoon;
